import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutQuickInfoDistanceProfile extends Layout {
	panelQuickInfo: Panel;
	sourceDistanceProfile: DataSource;
	textboxID: Textbox;
	textboxLookupType: Textbox;
	textboxMethod: Textbox;
	textboxServer: Textbox;
	textboxVersion: Textbox;
}
